var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"navWrap",staticClass:"tabs"},[(_vm.activeIndex >= 0)?_c('div',{ref:"tabLine",staticClass:"tab-line",style:(_vm.barStyle)}):_vm._e(),_vm._l((_vm.tabList),function(item,tabIndex){return _c('div',{key:item.label,staticClass:"tab-item",style:({
        color: tabIndex === _vm.activeIndex ? _vm.activeColor : _vm.normalColor,
        fontSize: _vm.fontSize,
        fontWeight: tabIndex === _vm.activeIndex ? 'bold' : 400
      }),on:{"click":function($event){return _vm.handleTabChange(tabIndex)}}},[_vm._t("content",function(){return [_vm._v(" "+_vm._s(item.label)+" ")]},{"tab":item,"tabIndex":tabIndex})],2)})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }